import { RangeCalendar } from "./RangeCalendar";

export default RangeCalendar;
